import styled from '@emotion/styled';
import { css } from 'emotion';
import {
  BREAKPOINT_SMALL,
  COLOR_DARK_PURPLE,
} from '../../../../../../components/MarketingPagesShared/styles';

export const mutedTextColor = 'rgba(255, 255, 255, 0.6)';
const solidGrayBackground = 'rgb(196, 198, 200)';
const mutedGrayBackground = 'rgba(196, 198, 200, 0.2)';

export const typeaheadClassName = css`
  flex: 1;

  .rbt-input-wrapper {
    margin-right: 35px;
  }

  .rbt-input {
    height: auto;
    margin: 0;
    padding: 15px 35px;
    border: 0;
    border: 2px solid #9f6fff;
    border-radius: 80px;
    font-size: 1.5rem;
    background: transparent;
  }

  .rbt-input-hint {
    /* This color is hardcoded into the library code and added in the style
       props, and there's no hook for adding a custom style */
    color: ${mutedTextColor} !important;
  }

  .dropdown-menu {
    right: 0;
    max-height: 600px !important;
    margin: 15px 20px;
    padding: 0;
    border: 0;
    font-size: 1rem;
    background: ${COLOR_DARK_PURPLE};
    box-shadow: none;

    ::-webkit-scrollbar {
      width: 5px;
    }
    ::-webkit-scrollbar-track {
      border-radius: 4px;
      background: ${mutedGrayBackground};
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background: ${solidGrayBackground};
    }

    .dropdown-item {
      margin-right: 5px;
      padding: 15px;
      border-radius: 4px;
      color: ${mutedTextColor};
      font-size: 1.5rem;

      &.active {
        background: ${mutedGrayBackground};
      }

      &:hover:not(.disabled) {
        background: #9f6fff;
      }

      &.disabled {
        &,
        &:hover {
          color: ${mutedTextColor};
          cursor: default;
        }
      }
    }
  }

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    .rbt-input {
      padding: 12px 25px;
      font-size: 1rem;
    }
    .rbt-input-wrapper {
      margin-right: 25px;
    }

    .dropdown-menu {
      max-height: 300px !important;
      margin: 10px 0 0;

      .dropdown-item {
        padding: 15px;
        font-size: 1rem;
      }
    }
  }
`;

export const infoButtonClassName = css`
  display: block;
  font-size: 0.875rem;
  line-height: 1.3;
  box-shadow: none;
  &:before {
    box-shadow: none;
  }
`;

export const caretIconClassName = css`
  margin-left: 5px;
`;

export const inputFieldClassName = css`
  position: relative;
  z-index: 1;
  width: 100%;
  color: white;
  &::placeholder {
    color: ${mutedTextColor};
  }
`;

export const PopupAnchor = styled.a`
  line-height: 1;
  &,
  &:hover {
    color: white;
    text-decoration: underline;
  }
`;

export const InputWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const SearchIconWrapper = styled.div`
  position: absolute;
  right: 30px;
  font-size: 0;
  pointer-events: none;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    right: 18px;
  }
`;

export const EpisodeCount = styled.h5`
  margin: 0;
  width: 130px;
  text-align: right;
  font-weight: bold;
  font-size: 0.875rem;
`;

export const EpisodeCountText = styled.span`
  display: inline-block;
  margin-right: 5px;
`;

export const DesktopEpisodeCount = styled.div`
  @media (max-width: ${BREAKPOINT_SMALL}px) {
    display: none;
  }
`;

export const MobileEpisodeCount = styled.div`
  @media (min-width: ${BREAKPOINT_SMALL}px) {
    display: none;
  }
`;

export const SelectedPodcast = styled.div`
  display: flex;
  justify-content: center;
  padding: 30px;
  border-radius: 6px;
  font-size: 0.875rem;
  text-align: left;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    flex-direction: column;
    align-items: center;
    padding: 30px 0;
    text-align: center;
  }
`;

export const SelectedPodcastName = styled.h3`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  font-size: 1.5rem;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    display: block;
    margin: 24px 0 0;
  }
`;

export const SelectedPodcastAuthor = styled.h4`
  margin: 10px 0;
  font-size: 0.875rem;
`;

export const SelectedPodcastInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 100%;
`;

export const SelectedPodcastImage = styled.img`
  flex: 0 0 168px;
  width: 168px;
  height: 168px;
  border-radius: 6px;

  @media (min-width: ${BREAKPOINT_SMALL}px) {
    margin-right: 24px;
  }
`;

export const Message = styled.p`
  margin-top: 32px;
  color: white;
  font-size: 1rem;
`;

export const SelectedPodcastDescription = styled.p`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  color: inherit;
  line-height: 1.4;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 16px;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    align-items: center;
    margin: 24px 0;
  }
`;
